import React, { useState } from 'react';
import FormSection from '../../../../components/atom/FormSection';
import { useFormik } from 'formik';
import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { levelSelectOptions } from './AccountsPayableBlock';
import useExcelExport from '../../../../hooks/useExcelExport';
import { EXCEL_EXPORT_VARIANTS } from '../../../../tools/excelExportSchemas';
import { EXPORT_BATCH_VARIANTS } from '../BatchListPage';

const initialFilterValues = {
    fromDate: '',
    endDate: '',
    level: 'detailed'
};

const PaymentVarianceBlock = () => {
    const [apiError, setApiError] = useState(null);

    const { handleExport } = useExcelExport();

    const onSubmit = async data => {
        setApiError(null);
        try {
            await handleExport({
                variant:
                    data.level === 'summary'
                        ? EXCEL_EXPORT_VARIANTS.PAYMENT_VARIANCE_SUMMARY
                        : EXCEL_EXPORT_VARIANTS.PAYMENT_VARIANCE_DETAILED,
                params: {
                    exportVariant: EXPORT_BATCH_VARIANTS.PAYMENT_VARIANCE,
                    fromDate: data.fromDate,
                    endDate: data.endDate,
                    level: data.level
                }
            });
        } catch (error) {
            if (error.status === 404) {
                setApiError('No batches found for the provided filters');
            } else {
                console.log('error', error);
                setApiError(error || 'An error occurred while exporting batches');
            }
        }
        setSubmitting(false);
    };

    const { values, isValid, isSubmitting, setFieldValue, handleSubmit, setSubmitting } = useFormik(
        {
            initialValues: initialFilterValues,
            onSubmit: data => onSubmit(data)
        }
    );

    const handleInputChange = (event, field) => {
        const { value } = event.target;
        setFieldValue(field, value);
        setApiError(null);
    };

    return (
        <FormSection title="Payment variance">
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item container className="golf-picker" justifyContent="center">
                        <TextField
                            type="date"
                            label="From"
                            fullWidth
                            value={values.fromDate}
                            name="fromDate"
                            onChange={e => handleInputChange(e, 'fromDate')}
                            InputLabelProps={{
                                shrink: true
                            }}
                            disabled={isSubmitting}
                        />
                    </Grid>
                    <Grid item container className="golf-picker" justifyContent="center">
                        <TextField
                            type="date"
                            label="Thru"
                            fullWidth
                            value={values.endDate}
                            name="endDate"
                            onChange={e => handleInputChange(e, 'endDate')}
                            InputLabelProps={{
                                shrink: true
                            }}
                            disabled={isSubmitting}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="level-select">Level</InputLabel>
                            <Select
                                fullWidth
                                labelId="level-select"
                                value={values.level}
                                size="small"
                                label="Level"
                                onChange={e => {
                                    handleInputChange(e, 'level');
                                }}
                                disabled={isSubmitting}
                            >
                                {Object.entries(levelSelectOptions).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {apiError && (
                        <Grid item xs={12}>
                            <Alert severity="error">{apiError}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            size="small"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting || !isValid}
                            type="submit"
                        >
                            Export
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </FormSection>
    );
};

export default PaymentVarianceBlock;
